/* Größenberater (Stanley/Stella: T-Shirt, Longsleeve, Sweatshirt, Hoodie je mit eigener Tabelle und Logik).
   Öffnen läuft über Event-Delegation auf document ([data-vh-sizeguide-open], der Link
   "Größentabelle ›" in der GRÖSSE-Labelzeile), damit auch per innerHTML injizierte
   Kopien (Quick-Add-Modal) funktionieren. Die Logik im Dialog wird beim ersten Öffnen
   direkt an den Dialog gebunden, und ALLE Events werden am Dialog-Rand gestoppt:
   die Theme-Komponenten (variant-picker, product-form) reagieren sonst auf
   bubbelnde input/change-Events und setzen Eingaben zurück.
   Brief 4.1 Punkt 4: beim Öffnen history.pushState, popstate und Escape schließen,
   Fokus wandert in den Dialog und beim Schließen zurück auf den Öffner. */
(function () {
  if (window.__vhSizeGuide) return;
  window.__vhSizeGuide = true;

  /* Je Kleidungsart (data-vh-sg-kind am Dialog, aus dem Produkttyp, snippets/vh-size-guide.liquid):
     halbe Brustweite c, Körperlänge l, Ärmellänge s in cm laut offiziellen Stanley/Stella-Datenblättern,
     Ziel-Mehrweite je Passform, Mindestlänge und Ärmelregel. Recherche und 360 Testfälle (24.10.2026):
     Website/groessenberater (rechenregeln.txt, testfaelle.csv). Das T-Shirt ist unverändert.
     sleeve: 0 = keine Ärmelregel, 1 = nur Hinweis, 2 = Bedingung (Hoodie/Sweatshirt); sleeveAdd = Zuschlag für
     die abgesenkte Schulter (Sweatshirt 7,5 cm), ab Index sleeveCap (L) gilt die Bedingung immer. */
  var GARMENTS = {
    // T-Shirt: Creator 2.0 (STTU169). Kalibriert auf 180/74 körpernah = S, 190/95 körpernah = L und (Cano 25.10.2026,
    // trägt es selbst) 180/81 körpernah = S. Dafür darf „körpernah“ bis 3 cm enger sitzen als die geschätzte Brust (Jersey).
    shirt: {
      sizes: [
        { n: 'XS', c: 47.5, l: 65 }, { n: 'S', c: 49.5, l: 69 }, { n: 'M', c: 53.5, l: 73 },
        { n: 'L', c: 56.5, l: 75 }, { n: 'XL', c: 59.5, l: 77 }, { n: 'XXL', c: 63.5, l: 79 }
      ],
      ease: { slim: -0.4 }, minEase: -3, minLen: 0.375, sleeve: 0
    },
    // Longsleeve: Creator 2.0 Long Sleeve (STTU199), gleicher Rumpf wie das T-Shirt, Ärmel nur als Hinweis
    longsleeve: {
      sizes: [
        { n: 'XS', c: 47.5, l: 65, s: 61.5 }, { n: 'S', c: 49.5, l: 69, s: 63 }, { n: 'M', c: 53.5, l: 73, s: 64.5 },
        { n: 'L', c: 56.5, l: 75, s: 65 }, { n: 'XL', c: 59.5, l: 77, s: 65.5 }, { n: 'XXL', c: 63.5, l: 79, s: 66 }
      ],
      ease: { slim: -0.4 }, minEase: -3, minLen: 0.375, sleeve: 1, sleeveAdd: 0
    },
    // Sweatshirt: Radder 2.0 (STSU208), Oversize, +28 cm Brustumfang gegenüber dem T-Shirt
    sweatshirt: {
      sizes: [
        { n: 'XS', c: 61.5, l: 65, s: 53 }, { n: 'S', c: 63.5, l: 69, s: 57 }, { n: 'M', c: 67.5, l: 73, s: 59 },
        { n: 'L', c: 70.5, l: 75, s: 61 }, { n: 'XL', c: 73.5, l: 77, s: 61.5 }, { n: 'XXL', c: 77.5, l: 79, s: 62 }
      ],
      /* 3,5 cm weniger als die Recherche (30,5): Cano trägt es bei 1,80 m und 80 bis 81 kg in S (25.10.2026) */
      ease: { slim: 27 }, minLen: 0.35, sleeve: 2, sleeveAdd: 7.5, sleeveCap: 3
    },
    // Hoodie: Cruiser 2.0 (STSU177), Relaxed, +11 cm Brustumfang gegenüber dem T-Shirt
    hoodie: {
      sizes: [
        { n: 'XS', c: 53, l: 67, s: 60.5 }, { n: 'S', c: 55, l: 71, s: 64.5 }, { n: 'M', c: 59, l: 74, s: 66.5 },
        { n: 'L', c: 62, l: 76, s: 68.5 }, { n: 'XL', c: 65, l: 78, s: 69 }, { n: 'XXL', c: 69, l: 80, s: 69.5 }
      ],
      /* 3 cm weniger Luft als die Recherche (13,5): Cano trägt bei 1,80 m und 81 kg S körpernah und findet es
         perfekt, vorher kam M (25.10.2026) */
      ease: { slim: 10.5 }, minLen: 0.35, sleeve: 2, sleeveAdd: 0, sleeveCap: 3
    }
  };
  /* Texte in der Sprache der Seite (window.vhStrings aus layout/theme.liquid), Deutsch als Rueckfall */
  var T = window.vhStrings || {};
  var FIT_DEFAULT = { slim: 'körpernah', regular: 'Standard', loose: 'locker' };
  function fitLabels(kind) {
    var byKind = T.sgFitKind || {};
    return byKind[kind] || T.sgFit || FIT_DEFAULT;
  }
  function garmentOf(dlg) {
    return GARMENTS[dlg.getAttribute('data-vh-sg-kind')] || GARMENTS.shirt;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Passform = Abstand zur körpernahen Größe (Cano 25.10.2026): Standard eine Größe größer, locker zwei. Vorher hatte
     jede Passform ein eigenes Mehrweiten-Ziel, die lagen enger beieinander als die Größensprünge, dadurch ergaben
     „körpernah“ und „Standard“ bei rund zwei Dritteln aller Eingaben dieselbe Größe. */
  var FIT_STEP = { slim: 0, regular: 1, loose: 2 };
  function recommend(h, w, fit, G) {
    G = G || GARMENTS.shirt;
    var base = slimSize(h, w, G);
    var step = FIT_STEP[fit] || 0;
    if (!step || base.capped) return base;
    var SIZES = G.sizes, last = SIZES.length - 1, i = 0;
    while (i < last && SIZES[i].n !== base.size) i++;
    var capped = i + step > last;
    i = Math.min(last, i + step);
    var arm = 0.374 * h - 6.4;
    var sleeveShort = !!G.sleeve && SIZES[i].s + (G.sleeveAdd || 0) < arm - 1;
    return { size: SIZES[i].n, capped: capped, driven: '', sleeveShort: sleeveShort }; /* „für die Länge …“ gilt nur für körpernah */
  }

  /* Körpernahe Größe: Brust-Mehrweite am Ziel, dazu Mindestlänge und Ärmel */
  function slimSize(h, w, G) {
    var fit = 'slim';
    var SIZES = G.sizes;
    // Brustumfang-Schätzung nach ANSUR-II-Regression (ziviles Niveau):
    // negativer Größen-Koeffizient, bei gleichem Gewicht sind Größere schlanker.
    var chest = 0.63 * w - 0.28 * h + 99.5;
    var minLen = G.minLen * h; // Mindestlänge, sonst wirkt es zu kurz
    // Ease-Ziel skaliert mit der Körpergröße (+0,2 cm pro cm über/unter 175, Größe auf 160 bis 200 begrenzt)
    var hClamped = Math.min(200, Math.max(160, h));
    var target = (G.ease[fit] || G.ease.slim) + 0.2 * (hClamped - 175);
    // Geschätzte Armlänge (Schulterpunkt bis Handgelenk, ANSUR II), ungekappt
    var arm = 0.374 * h - 6.4;
    var add = G.sleeveAdd || 0;
    // Zu wenig Luft wiegt dreifach (lieber etwas weiter als zu eng), negative Mehrweite ist ausgeschlossen.
    var score = function (ease) {
      return ease < target ? 3 * (target - ease) : ease - target;
    };
    var lenOk = function (i) { return SIZES[i].l >= minLen; };
    var sleeveOk = function (i) {
      if (G.sleeve !== 2) return true;
      if (i >= G.sleeveCap) return true;
      return SIZES[i].s + add >= arm;
    };
    // Sieger nur nach Brust, mit Länge, mit Ärmel, mit beidem. Strikt „<“: bei Gleichstand gewinnt die kleinere Größe.
    var bChest = -1, bLen = -1, bSleeve = -1, best = -1;
    var better = function (cur, i, ease) { return cur < 0 || score(ease) < score(2 * SIZES[cur].c - chest); };
    for (var i = 0; i < SIZES.length; i++) {
      var ease = 2 * SIZES[i].c - chest;
      if (ease < (G.minEase || 0)) continue;
      if (better(bChest, i, ease)) bChest = i;
      if (lenOk(i) && better(bLen, i, ease)) bLen = i;
      if (sleeveOk(i) && better(bSleeve, i, ease)) bSleeve = i;
      if (lenOk(i) && sleeveOk(i) && better(best, i, ease)) best = i;
    }
    if (best < 0) {
      return { size: SIZES[SIZES.length - 1].n, capped: true, driven: '', sleeveShort: false };
    }
    // Größer als nach Brust allein: Länge, Ärmel oder beides
    var driven = '';
    if (bChest > -1 && best > bChest) {
      var byLen = bLen === best, bySleeve = G.sleeve === 2 && bSleeve === best;
      driven = byLen && bySleeve ? 'both' : (bySleeve ? 'sleeve' : (byLen ? 'length' : 'both'));
    }
    var sleeveShort = !!G.sleeve && SIZES[best].s + add < arm - 1;
    return { size: SIZES[best].n, capped: false, driven: driven, sleeveShort: sleeveShort };
  }
  window.vhSizeRecommend = recommend; /* nur für Tests */
  window.vhSizeGarments = GARMENTS;

  /* Größentabelle aus den Daten der Kleidungsart (mit Ärmel-Spalte, wenn vorhanden) */
  function fillTable(dlg) {
    var body = dlg.querySelector('[data-vh-sg-tbody]');
    if (!body || body.__vhFilled) return;
    body.__vhFilled = true;
    var G = garmentOf(dlg);
    var dec = dlg.getAttribute('data-vh-sg-dec') || ',';
    var f = function (v) { return String(v).replace('.', dec) + ' cm'; };
    body.innerHTML = G.sizes.map(function (z) {
      return '<tr><td>' + z.n + '</td><td>' + f(z.c) + '</td><td>' + f(z.l) + '</td>' + (z.s != null ? '<td>' + f(z.s) + '</td>' : '') + '</tr>';
    }).join('');
  }

  function activeFit(dlg) {
    var btn = dlg.querySelector('[data-vh-sg-fit].is-active');
    return btn ? btn.getAttribute('data-vh-sg-fit') : 'slim';
  }

  function update(dlg) {
    var out = dlg.querySelector('[data-vh-sg-result]');
    if (!out) return;
    var h = parseFloat((dlg.querySelector('[data-vh-sg-height]') || {}).value);
    var w = parseFloat((dlg.querySelector('[data-vh-sg-weight]') || {}).value);
    if (!h || !w) {
      out.innerHTML = '<p class="vh-sizeguide__hint">' + esc(T.sgHint || 'Gib deine Körpergröße und dein Gewicht ein.') + '</p>';
      return;
    }
    if (h < 140 || h > 210 || w < 40 || w > 150) {
      out.innerHTML = '<p class="vh-sizeguide__hint">' + esc(T.sgCheck || 'Bitte prüfe deine Angaben (140 bis 210 cm, 40 bis 150 kg).') + '</p>';
      return;
    }
    var fit = activeFit(dlg);
    var r = recommend(h, w, fit, garmentOf(dlg));
    var FIT_LABEL = fitLabels(dlg.getAttribute('data-vh-sg-kind'));
    var basis = T.sgBasis
      ? T.sgBasis.replace('%H', Math.round(h)).replace('%W', Math.round(w)).replace('%F', FIT_LABEL[fit])
      : 'Bei ' + Math.round(h) + ' cm und ' + Math.round(w) + ' kg, Passform ' + FIT_LABEL[fit] + '.';
    var note = r.capped
      ? (T.sgLargest || 'Das ist unsere größte Größe. Bei dir fällt sie eher körpernah aus.')
      : basis;
    if (r.driven === 'length') {
      note += ' ' + (T.sgLength || 'Diese Größe brauchst du für die Länge, an der Brust sitzt sie etwas lockerer.');
    } else if (r.driven === 'sleeve') {
      note += ' ' + (T.sgSleeve || 'Diese Größe brauchst du für die Ärmellänge, an der Brust sitzt sie etwas lockerer.');
    } else if (r.driven === 'both') {
      note += ' ' + (T.sgBoth || 'Diese Größe brauchst du für Länge und Ärmel, an der Brust sitzt sie etwas lockerer.');
    }
    if (r.sleeveShort) {
      note += ' ' + (T.sgSleeveShort || 'Bei deiner Körpergröße enden die Ärmel eventuell knapp am Handgelenk.');
    }
    note = esc(note);
    // Nur einen Übernehmen-Button anbieten, wenn die Größe im Produkt wählbar ist
    var applyable = findSizeOption(dlg, r.size);
    var apply = applyable
      ? '<button type="button" class="vh-sizeguide__apply" data-vh-sg-apply="' + r.size + '">' + esc(T.sgApply ? T.sgApply.replace('%S', r.size) : 'Größe ' + r.size + ' übernehmen') + '</button>'
      : '';
    out.innerHTML =
      '<p class="vh-sizeguide__reco">' + esc(T.sgReco || 'Unsere Empfehlung:') + ' <strong>' + r.size + '</strong></p>' +
      '<p class="vh-sizeguide__why">' + note + '</p>' +
      apply;
  }

  // Produkt-Kontext (Produktseite oder Quick-Add-Modal), in dem der Berater steckt
  function productScope(el) {
    var wrap = el.closest('.vh-sizeguide') || el;
    return wrap.closest('.quick-add-modal') || wrap.closest('.product-details') || document;
  }

  // Das <select> und die <option>, die zu einer Größe gehören (nur das Size-Dropdown hat XS/S/M...)
  function findSizeOption(dlg, size) {
    var scope = productScope(dlg);
    var selects = scope.querySelectorAll('.variant-option__select');
    for (var i = 0; i < selects.length; i++) {
      for (var j = 0; j < selects[i].options.length; j++) {
        if (selects[i].options[j].value === size) {
          return { select: selects[i], option: selects[i].options[j] };
        }
      }
    }
    return null;
  }

  function applySize(dlg, size) {
    var found = findSizeOption(dlg, size);
    if (!found) return;
    var apply = function () {
      found.select.value = size;
      found.select.dispatchEvent(new Event('change', { bubbles: true }));
    };
    // Erst den History-Eintrag des Dialogs abräumen (der close-Handler ruft history.back()),
    // dann die Größe setzen: variant-picker.js schreibt ?variant= per replaceState sonst auf den
    // Dialog-Eintrag statt auf den Ziel-Eintrag, und nach dem Back zeigt die URL die alte Variante.
    if (dlg.__vhPushed) {
      var done = false;
      var run = function () {
        if (done) return;
        done = true;
        window.removeEventListener('popstate', run);
        apply();
      };
      window.addEventListener('popstate', run);
      setTimeout(run, 300);
      dlg.close();
      return;
    }
    dlg.close();
    apply();
  }

  /* Dialog zu einem Öffner finden: zuerst im eigenen .vh-sizeguide, sonst im
     Produkt-Kontext (der Link sitzt in der Labelzeile innerhalb von <variant-picker>). */
  function dialogFor(openBtn) {
    var wrap = openBtn.closest('.vh-sizeguide');
    var dlg = wrap && wrap.querySelector('[data-vh-sizeguide-dialog]');
    if (dlg) return dlg;
    var scope = openBtn.closest('.quick-add-modal') || openBtn.closest('dialog') || openBtn.closest('.product-details') || document;
    return scope.querySelector('[data-vh-sizeguide-dialog]');
  }

  function openDialog(dlg, opener) {
    bind(dlg);
    if (dlg.open) return;
    dlg.__vhOpener = opener || document.activeElement;
    // History-Eintrag, damit "Zurück" (Browser, iOS-Wischgeste) den Dialog schließt statt die Seite zu verlassen
    dlg.__vhPushed = false;
    try {
      history.pushState({ vhSizeGuide: true }, '');
      dlg.__vhPushed = true;
    } catch (err) { /* ohne History-Eintrag funktioniert der Dialog trotzdem */ }
    fillTable(dlg);
    dlg.showModal();
    update(dlg);
    // Fokus in den Dialog (Container, nicht ins Zahlenfeld: sonst springt auf iOS sofort die Tastatur auf)
    var inner = dlg.querySelector('.vh-sizeguide__inner');
    try {
      (inner || dlg).focus({ preventScroll: true });
    } catch (err) {
      (inner || dlg).focus();
    }
  }

  function bind(dlg) {
    if (dlg.__vhBound) return;
    dlg.__vhBound = true;

    // Escape schließt (explizit, der Browser-Default wird unten per stopPropagation nicht berührt,
    // aber so ist das Verhalten in allen Browsern identisch)
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        if (dlg.open) dlg.close();
      }
    });

    // Beim Schließen (Escape, X, Backdrop, Übernehmen): eigenen History-Eintrag wieder entfernen,
    // Fokus zurück auf den Öffner
    dlg.addEventListener('close', function () {
      // Nur __vhPushed zählt: history.state kann inzwischen von variant-picker.js (replaceState)
      // überschrieben sein; der popstate-Handler unten setzt __vhPushed vorher auf false, kein doppeltes back
      if (dlg.__vhPushed) {
        dlg.__vhPushed = false;
        history.back();
      }
      dlg.__vhPushed = false;
      var opener = dlg.__vhOpener;
      dlg.__vhOpener = null;
      if (opener && opener.focus && document.contains(opener)) {
        try {
          opener.focus({ preventScroll: true });
        } catch (err) {
          opener.focus();
        }
      }
    });

    dlg.addEventListener('click', function (e) {
      var fitBtn = e.target.closest('[data-vh-sg-fit]');
      if (fitBtn) {
        dlg.querySelectorAll('[data-vh-sg-fit]').forEach(function (b) {
          var on = b === fitBtn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        update(dlg);
      } else if (e.target.closest('[data-vh-sg-apply]')) {
        applySize(dlg, e.target.closest('[data-vh-sg-apply]').getAttribute('data-vh-sg-apply'));
      } else if (e.target.closest('[data-vh-sizeguide-close]')) {
        dlg.close();
      } else if (e.target.closest('[data-vh-sg-tabletoggle]')) {
        var toggle = e.target.closest('[data-vh-sg-tabletoggle]');
        var table = dlg.querySelector('[data-vh-sg-table]');
        var show = table.hasAttribute('hidden');
        if (show) table.removeAttribute('hidden');
        else table.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', show ? 'true' : 'false');
        toggle.textContent = show ? (T.sgTableHide || 'Größentabelle ausblenden') : (T.sgTableShow || 'Größentabelle anzeigen');
      } else if (e.target === dlg) {
        // Klick auf den Backdrop schließt
        dlg.close();
      }
      e.stopPropagation();
    });

    dlg.addEventListener('input', function (e) {
      if (e.target.matches('[data-vh-sg-height], [data-vh-sg-weight]')) update(dlg);
      e.stopPropagation();
    });

    // Nichts davon darf die Theme-Komponenten außerhalb erreichen
    ['change', 'keydown', 'keyup', 'keypress', 'pointerdown', 'pointerup', 'focusin', 'focusout', 'submit'].forEach(function (t) {
      dlg.addEventListener(t, function (e) { e.stopPropagation(); });
    });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-vh-sizeguide-open]');
    if (!openBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var dlg = dialogFor(openBtn);
    if (dlg) openDialog(dlg, openBtn);
  });

  // Browser-Zurück (auch iOS-Wischgeste) schließt einen offenen Dialog; der History-Eintrag
  // ist durch den Back-Schritt bereits weg, deshalb kein zweites history.back() im close-Handler
  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-vh-sizeguide-dialog][open]').forEach(function (dlg) {
      dlg.__vhPushed = false;
      dlg.close();
    });
  });
})();
